"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GpsLossUsers = exports.UserPortalManagment = exports.UserAppManagment = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var layout_1 = require("../_shared/components/layout");
var model_1 = require("../../model");
var UsersTable_1 = require("./partials/UsersTable");
var UserActions_1 = require("./UserActions");
var SearchInput_1 = require("../_shared/components/inputs/SearchInput");
var UserManagementReducer_1 = require("./UserManagementReducer");
var UserFormTabs_1 = require("./partials/UserFormTabs");
var PortalPage_1 = require("../_shared/components/PortalPage");
require("./UserManagementPage.scss");
var LoginActions_1 = require("../_shared/reducers/loginState/LoginActions");
var OnlineTable_1 = require("../_shared/components/OnlineTable");
var LoginReducer_1 = require("../_shared/reducers/loginState/LoginReducer");
var UserManagementComponent = /** @class */ (function (_super) {
    __extends(UserManagementComponent, _super);
    function UserManagementComponent(props) {
        var _this = this;
        var _a, _b, _c;
        _this = _super.call(this, props) || this;
        var tableSettings = ((_a = props.identity) === null || _a === void 0 ? void 0 : _a.tableSettings) || null;
        _this.state = {
            rowSelected: -1,
            selectedUser: __assign(__assign({}, model_1.emptyUser), { type: _this.props.userType }),
            tableExpanded: true,
            filterText: '',
            appUsersPageSize: ((_b = tableSettings === null || tableSettings === void 0 ? void 0 : tableSettings.appUsersTable) === null || _b === void 0 ? void 0 : _b.pageSize) || OnlineTable_1.DEFAULT_PAGE_SIZE,
            portalUsersPageSize: ((_c = tableSettings === null || tableSettings === void 0 ? void 0 : tableSettings.portalUsersTable) === null || _c === void 0 ? void 0 : _c.pageSize) || OnlineTable_1.DEFAULT_PAGE_SIZE,
        };
        return _this;
    }
    UserManagementComponent.prototype.componentWillMount = function () {
        this.props.loadCompanies();
    };
    UserManagementComponent.prototype.componentWillReceiveProps = function (newProps) {
        // IF we have a user without ID selected (new) and he come back as added,
        if (this.state.selectedUser.username && this.state.selectedUser._id === null) {
            var updatedUser = (0, UserManagementReducer_1.getUserByUserName)(this.props.userState, this.state.selectedUser.username);
            // Then we updated his ID for future, and updated first row
            if (updatedUser && updatedUser._id) {
                this.setState({ selectedUser: updatedUser, rowSelected: 0 });
            }
        }
    };
    UserManagementComponent.prototype.componentWillUnmount = function () {
        this.props.clearUsers();
    };
    UserManagementComponent.prototype.updateUser = function (user) {
        // Update on server
        this.props.updateUser(this.state.selectedUser._id, user);
        // In local
        this.setState({ selectedUser: __assign(__assign({}, this.state.selectedUser), user) });
    };
    UserManagementComponent.prototype.componentDidMount = function () {
        //
    };
    UserManagementComponent.prototype.onNewUser = function () {
        this.setState({ rowSelected: -1, selectedUser: __assign(__assign({}, model_1.emptyUser), { type: this.props.userType }), tableExpanded: false });
    };
    UserManagementComponent.prototype.onNewAdminUser = function () {
        this.setState({
            rowSelected: -1,
            selectedUser: __assign(__assign({}, model_1.emptyUser), { type: this.props.userType, role: model_1.UserRoles.ADMIN }),
            tableExpanded: false,
        });
    };
    UserManagementComponent.prototype.isSuperAdmin = function () {
        return this.props.identity.role === model_1.UserRoles.SUPERADMIN;
    };
    /** Who may grant access to the GPS worklog proposal preview. */
    UserManagementComponent.prototype.canGrantGpsProposal = function () {
        return this.props.identity.role === model_1.UserRoles.ADMIN
            || this.props.identity.role === model_1.UserRoles.SUPERADMIN;
    };
    UserManagementComponent.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var page = this.props.gpsLossOnly
            ? model_1.Permission.PAGE_GPS_LOSS_USERS
            : this.props.userType === model_1.UserType.PORTAL
                ? model_1.Permission.PAGE_PORTAL_USERS
                : model_1.Permission.PAGE_APP_USERS;
        return (React.createElement(PortalPage_1.default, { id: "user-management-page", page: page, isLoading: this.props.apiState.isLoading },
            React.createElement(layout_1.Row, null,
                React.createElement(layout_1.Column, { width: this.state.tableExpanded ? '100%' : '70%' },
                    React.createElement("div", { className: "table-container" },
                        React.createElement("div", { className: "fullWidth fix-height-top" },
                            React.createElement(layout_1.Wrapper, { paddingVertical: "8px 12px" },
                                React.createElement(layout_1.Row, { justifyContent: "flex-end" },
                                    React.createElement(SearchInput_1.SearchInput, { onChange: function (filterText) { return _this.setState({ filterText: filterText }); } }),
                                    this.props.userType === model_1.UserType.PORTAL && (React.createElement("span", { className: "button add-user-btn", onClick: function () { return _this.onNewUser(); } }, "Gebruiker toevoegen")),
                                    this.props.userType === model_1.UserType.PORTAL && this.isSuperAdmin() && (React.createElement("span", { className: "button add-admin-btn", onClick: function () { return _this.onNewAdminUser(); } }, "Admin toevoegen")),
                                    this.props.gpsLossOnly
                                        ? null
                                        : React.createElement("i", { className: "material-icons", onClick: function () { return _this.setState({ tableExpanded: !_this.state.tableExpanded }); } }, this.state.tableExpanded ? 'keyboard_arrow_right' : 'keyboard_arrow_left')))),
                        React.createElement("div", { className: "users-table" },
                            React.createElement(UsersTable_1.default, { defaultPageSize: this.props.userType === model_1.UserType.PORTAL ?
                                    this.state.portalUsersPageSize : this.state.appUsersPageSize, userType: this.props.userType, rowSelected: this.state.rowSelected, onSelectUser: function (index, user) {
                                    return _this.setState({ rowSelected: index, selectedUser: user, tableExpanded: false });
                                }, filterText: this.state.filterText, gpsLossOnly: this.props.gpsLossOnly, onPageSizeChangeCallback: function (pageSize) {
                                    return (0, LoginReducer_1.saveTableSettings)(_this.props, (_this.props.userType === model_1.UserType.PORTAL ? 'portalUsersTable' : 'appUsersTable'), { pageSize: pageSize });
                                } })))),
                React.createElement("div", null,
                    " ",
                    React.createElement("div", { className: 'edit-user-container' + ' ' + (this.state.tableExpanded ? 'hidden' : '') },
                        React.createElement(layout_1.Column, null,
                            React.createElement(UserFormTabs_1.UserFormTabs, { selectedUser: this.state.selectedUser, updateUser: function (user) { return _this.updateUser(user); }, isSuperAdmin: this.isSuperAdmin(), canGrantGpsProposal: this.canGrantGpsProposal(), checkEmailExists: this.props.checkEmailExists, currentUserCompanyIds: (_b = (_a = this.props.identity) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.companies })))))));
    };
    return UserManagementComponent;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        identity: reducer.authentication.user,
        userState: reducer.manageUsersState,
        apiState: reducer.api.searchUsers,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    loadCompanies: function () { return UserActions_1.UserActions.loadCompanies()(dispatch); },
    updateUser: function (id, user) { return UserActions_1.UserActions.update(id, user)(dispatch); },
    clearUsers: function () { return UserActions_1.UserActions.clearUsers()(dispatch); },
    updateTableSettings: function (id, user) { return LoginActions_1.LoginActions.updateProfile(id, user)(dispatch); },
    checkEmailExists: function (email) { return UserActions_1.UserActions.checkEmailExists(email)(dispatch); },
}); };
var mergeProps = function (stateProps, dispatchProps, ownProps) {
    return __assign(__assign(__assign({}, stateProps), dispatchProps), ownProps);
};
var UserPage = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(UserManagementComponent);
var UserAppManagment = function () { return (React.createElement(UserPage, { userType: model_1.UserType.APP })); };
exports.UserAppManagment = UserAppManagment;
var UserPortalManagment = function () { return (React.createElement(UserPage, { userType: model_1.UserType.PORTAL })); };
exports.UserPortalManagment = UserPortalManagment;
var GpsLossUsers = function () { return (React.createElement(UserPage, { userType: model_1.UserType.APP, gpsLossOnly: true })); };
exports.GpsLossUsers = GpsLossUsers;
